import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import RestakeTabContext from '@/context/RestakeTabContext';
import TokenInputContext from '@/context/TokenInputContext';
import useQuery from '@/hooks/useQuery';
import { extractToTokenNameByName } from '@/utils/regex';
import { cn } from '@/utils/styles';

const { useRestakeTabTracked } = RestakeTabContext;
const { useTokenInputTracked } = TokenInputContext;

function FormTagSelector() {
  const navigate = useNavigate();
  const query = useQuery();
  const { t } = useTranslation();

  const [restakeTab] = useRestakeTabTracked();
  const [, setTokenInputTracked] = useTokenInputTracked();

  return (
    <div className="grid grid-cols-2 gap-1 p-1 border border-white cursor-pointer place-items-center border-opacity-10 rounded-xl">
      <Tag
        selected={restakeTab === 'deposit'}
        onClick={() => {
          const newQuery = new URLSearchParams();
          const symbol = query.get('symbol');
          const chain = query.get('chain');
          if (symbol) {
            newQuery.set('symbol', symbol);
          } else if (chain) {
            newQuery.set('chain', chain);
          }
          navigate(`/?${newQuery.toString()}`);
          setTokenInputTracked('');
        }}
      >
        {t('restake.deposit')}
      </Tag>
      <Tag
        selected={restakeTab === 'unstake'}
        onClick={() => {
          const newQuery = new URLSearchParams();
          const symbol = query.get('symbol');
          const chain = query.get('chain');
          if (symbol) {
            newQuery.set('symbol', extractToTokenNameByName(symbol));
          } else if (chain) {
            newQuery.set('chain', chain);
          }
          newQuery.set('tab', 'unstake');
          navigate(`/${newQuery.toString() !== '' ? `?${newQuery.toString()}` : ''}`);
          setTokenInputTracked('');
        }}
      >
        {t('restake.unstake')}
      </Tag>
    </div>
  );
}

const Tag = ({
  children,
  selected,
  onClick,
}: PropsWithChildren & {
  selected: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      className={cn(
        'rounded-xl text-[rgba(255,255,255,0.6)] w-full h-10 md:h-12 grid place-content-center duration-300 hover:bg-[#1F2636] text-sm font-bold',
        {
          'bg-[#1F2636] text-[rgba(255,255,255,0.8)]': selected,
        },
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default FormTagSelector;
